var contentWidth = $('.content').innerWidth();

$('.graphic').each(function (index, el) {
	var $this = $(this);

	if (!$this.hasClass('icon')) {
		$this.wrapInner('<div class="js-content"></div>')
			.append('<div class="graphic__tools js-buttons"></div>');

		if (!$this.hasClass('graphic--no-zoom')) {
			$this.addZoomIn('.js-content', '');
		}
	}
});



/** WEBPACK FOOTER **
 ** ./frontend/components/graphic/graphic.js
 **/